import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

const libreria = [
  NgxSpinnerModule,
  AppMaterialModule,
  RecaptchaModule,
  RecaptchaFormsModule
];

import {
  InicioRutasModule,
  INICIO_RUTAS_COMPONENTES
} from "./inicio-rutas.module";
import { AppMaterialModule } from '../shared/material/app-material.module';

@NgModule({
  imports: [
    CommonModule,
    InicioRutasModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    libreria
  ],
  declarations: [INICIO_RUTAS_COMPONENTES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InicioModule {}
